
import { Component, Vue } from "vue-property-decorator";
// import NavigationDrawer from "@/components/core/NavigationDrawer.vue";

const AppBar = () =>
  import(/* webpackChunkName: "AppBar" */ "@/components/core/AppBar.vue");

@Component({
  components: {
    //NavigationDrawer,
    AppBar,
  },
})
export default class Layout extends Vue {}
